import {InjectionToken, Provider} from '@angular/core';
export let DAYS_COUNTER_SERVICE: any = new InjectionToken<any>('tt.daysCounterService');

export function daysCounterFactory(i: any): any {
	return i.get('daysCounterService');
}

export const daysCounterServiceProvider: Provider = {
	provide: DAYS_COUNTER_SERVICE,
	useFactory: daysCounterFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/days-counter.service.ts